// @flow
const CREATE_ROLE = 'admin/role/CREATE_ROLE';
const CREATE_ROLE_FAIL = 'admin/role/CREATE_ROLE_FAIL';
const CREATE_ROLE_SUCCESS = 'admin/role/CREATE_ROLE_SUCCESS';
const DELETE_ROLE = 'admin/role/DELETE_ROLE';
const DELETE_ROLE_FAIL = 'admin/role/DELETE_ROLE_FAIL';
const DELETE_ROLE_SUCCESS = 'admin/role/DELETE_ROLE_SUCCESS';
const GET_ROLES = 'admin/role/GET_ROLES';
const GET_ROLES_FAIL = 'admin/role/GET_ROLES_FAIL';
const GET_ROLES_SUCCESS = 'admin/role/GET_ROLES_SUCCESS';
const SET_SELECTED_ROLE = 'admin/role/SET_SELECTED_ROLE';
const UPDATE_ROLE = 'admin/role/UPDATE_ROLE';
const UPDATE_ROLE_FAIL = 'admin/role/UPDATE_ROLE_FAIL';
const UPDATE_ROLE_SUCCESS = 'admin/role/UPDATE_ROLE_SUCCESS';

export {
  CREATE_ROLE,
  CREATE_ROLE_FAIL,
  CREATE_ROLE_SUCCESS,
  DELETE_ROLE,
  DELETE_ROLE_FAIL,
  DELETE_ROLE_SUCCESS,
  GET_ROLES,
  GET_ROLES_FAIL,
  GET_ROLES_SUCCESS,
  SET_SELECTED_ROLE,
  UPDATE_ROLE,
  UPDATE_ROLE_FAIL,
  UPDATE_ROLE_SUCCESS,
};

export type Role = {
  permissions: string[],
  name: string,
  uuid: string,
};

export type RoleState = {
  roles: Role[],
  selectedRoleId: ?string,
};

type CreateRoleAction = {|
  type: 'admin/role/CREATE_ROLE',
  payload: { session: string, roleName: string },
|};

type CreateRoleFailAction = {|
  type: 'admin/role/CREATE_ROLE_FAIL',
|};

type CreateRoleSuccessAction = {|
  type: 'admin/role/CREATE_ROLE_SUCCESS',
|};

type DeleteRoleAction = {|
  type: 'admin/role/DELETE_ROLE',
  payload: { session: string, roleName: string },
|};

type DeleteRoleFailAction = {|
  type: 'admin/role/DELETE_ROLE_FAIL',
|};

type DeleteRoleSuccessAction = {|
  type: 'admin/role/DELETE_ROLE_SUCCESS',
|};

type GetRolesAction = {|
  type: 'admin/role/GET_ROLES',
  payload: { session: string },
|};

type GetRolesFailAction = {|
  type: 'admin/role/GET_ROLES_FAIL',
|};

type GetRolesSuccessAction = {|
  type: 'admin/role/GET_ROLES_SUCCESS',
  payload: Role[],
|};

type SetSelectedRoleAction = {|
  type: 'admin/role/SET_SELECTED_ROLE',
  payload: Role,
|};

type UpdateRoleAction = {|
  type: 'admin/role/UPDATE_ROLE',
  payload: { session: string, roleName: string, grant: string, revoke: string },
|};

type UpdateRoleFailAction = {|
  type: 'admin/role/UPDATE_ROLE_FAIL',
|};

type UpdateRolesSuccessAction = {|
  type: 'admin/role/UPDATE_ROLE_SUCCESS',
|};

export type Action =
  | CreateRoleAction
  | CreateRoleFailAction
  | CreateRoleSuccessAction
  | DeleteRoleAction
  | DeleteRoleFailAction
  | DeleteRoleSuccessAction
  | GetRolesAction
  | GetRolesFailAction
  | GetRolesSuccessAction
  | SetSelectedRoleAction
  | UpdateRoleAction
  | UpdateRoleFailAction
  | UpdateRolesSuccessAction;



// WEBPACK FOOTER //
// ./src/state/types/roleTypes.js